import axiosInstance from "./AxiosConfig";
import endpoints from "./endpoints";

export const withdrawService = {
  withdrawalList: () =>
    axiosInstance.get(endpoints.tokenEndPoints.withdrawalList),
  withdrawalDetails: (id) =>
    axiosInstance.get(`${endpoints.tokenEndPoints.withdrawalDetails}/${id}`),
  withdrawalStatus: (id, data) =>
    axiosInstance.put(
      `${endpoints.tokenEndPoints.withdrawalStatus}/${id}`,
      data
    ),
};
